enum LoadingStatuses {
	INACTIVE = 0,
	ACTIVE = 1,
	FAILURE = 2
}

enum LoadingTypes {
	ACCOUNT_MANAGER = 'account_manager',
	CLIENT_SERVICES_PEOPLE = 'client_services_people',
	GENERIC = 'generic'
}

interface WindowNavigator {
	connection?: {
		downlink?: number;
	};
}

export { WindowNavigator, LoadingStatuses, LoadingTypes };
